import React from 'react';
import { Container } from 'react-bootstrap';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import CotizadorHNProvider from '../../context/CotizadorHNDataContext';
import CotizadorHN from './CotizadorHN';
import MicroSitioAutoHN from './MicroSitioAutoHN';


const MicrositioAutoHNRoot = () => {
    return (
        <CotizadorHNProvider>
            <Container>
                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    <Switch>
                        <Route exact path="/micrositio/cotizadorhn" component={CotizadorHN} />
                        <Route exact path="/micrositio/automovilhn" component={MicroSitioAutoHN} />
                    </Switch>
                </BrowserRouter>
            </Container>
        </CotizadorHNProvider>


    );
}

export default MicrositioAutoHNRoot;
